import Form from 'react-bootstrap/Form'
import { useId } from 'react'

export type SelectOption = {
    value: string
    label: string
}

export type SelectFieldProps = {
    label: string
    value: string
    options: SelectOption[]
    onChange: (value: string) => void
    error?: string
    helpText?: string
    disabled?: boolean
    required?: boolean
}

export function SelectField({ label, value, options, onChange, error, helpText, disabled, required }: SelectFieldProps) {
    const id = useId()

    return (
        <Form.Group className="mb-3" controlId={id}>
            <Form.Label>{label}</Form.Label>
            <Form.Select
                value={value}
                disabled={disabled}
                required={required}
                isInvalid={!!error}
                className="su-tappable"
                onChange={(event) => onChange(event.target.value)}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Form.Select>
            {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
            {helpText && !error && <Form.Text className="text-muted">{helpText}</Form.Text>}
        </Form.Group>
    )
}
